export class IncentiveLetterLetterPublishSelection {
  employeeTask: {
    id: '';
  };
  employeeMail: {
    id: '';
  };
  managerTask: {
    id: '';
  };
  managerMail: {
    id: '';
  };
}
